import React, { useContext } from 'react';
import UserIcon from '../../assets/img/user_icon.png';
import PrimaryButton from '../buttons/PrimaryButton';
import { TrackingContext } from '../context/Tracking';
import Rating from './Rating';

const categoryMapper = {
  team: 'Team',
  arbeitszeiten: 'Arbeitszeitmodell',
  weiterbildung: 'Weiterbildung',
  einarbeitung: 'Einarbeitung',
  infrastruktur: 'Infrastruktur',
  sonstiges: 'Sonstiges'
};
/* [
  {
    name: 'Team',
    key: 'team'
  },
  {
    name: 'Arbeitszeitmodell',
    key: 'arbeitszeiten'
  },
  {
    name: 'Weiterbildung',
    key: 'weiterbildung'
  },
  {
    name: 'Einarbeitung',
    key: 'einarbeitung'
  },
  {
    name: 'Infrastruktur',
    key: 'infrastruktur'
  },
  {
    name: 'Sonstiges',
    key: 'sonstiges'
  }
]; */

const ratingColors = {
  '-1': '#AB0000',
  0: '#748AFF',
  1: '#017421',
  null: 'grey'
};

const MAX_TEXT_LENGTH = 30;

const ratingObjectTester = ratingObject => {
  const tester = {
    // negative, undecided, positive
    recommended: [-1, 0, 1].includes(ratingObject.recommended),
    // text must be filled
    text: !!ratingObject.text,
    // timestamp
    timestamp: !!ratingObject.timestamp
  };
  if (Object.keys(tester).map(key => tester[key] === true)) return true;
  return false;
};

const colorMapper = ratingColors;

const getRatingValue = counts => {
  const sum = counts.p + counts.n + counts.u;
  if (sum === 0) return null;
  if (counts.p > (counts.n + counts.u)) return 1;
  if (counts.n > (counts.p + counts.u)) return -1;
  return 0;
};

const getRatingsByCategory = ratings => {
  const categories = ratings.map(r => r.category);
  const ratingsByType = categories.reduce((o, key) => ({ ...o, [key]: [] }), {});
  ratings.forEach(r => { ratingsByType[r.category].push(r); });
  console.log(ratingsByType);
  return ratingsByType;
};

const ratingValueIconMapper = {
  '-1': <i className='fa fa-minus rating-item' style={{ color: colorMapper[-1], fontSize: 16 }} />,
  0: <div style={{ backgroundColor: colorMapper[0], width: 12, height: 12, borderRadius: '50%' }} className='rating-item' />,
  1: <i className='fa fa-plus rating-item' style={{ color: colorMapper[1], fontSize: 16 }} />
};

const cutText = (text = '') => {
  if (text.length <= MAX_TEXT_LENGTH) return text;
  return text.slice(0, MAX_TEXT_LENGTH) + '...';
};

const hasToCut = text => {
  if (text.length <= MAX_TEXT_LENGTH) return false;
  return true;
};

const mapUserExperience = {
  Assistenzarztzeit: 'Assistent:in',
  'Assistenzärzt:in': 'Assistent:in',
  'Assistent:in': 'Assistent:in',
  PJ: 'PJler:in',
  'PJler:in': 'PJler:in',
  Famulatur: 'Famulant:in',
  'Famulant:in': 'Famulant:in',
  Berufsanfänger: 'Berufsanfänger:in',
  'Berufsanfänger:in': 'Berufsanfänger:in',
  Berufsstart: 'Berufsanfänger:in'
};

const mapRecommended = (word) => {
  try {
    return {
      Erfahreneren: 'Assistent:innen',
      Berufsstart: 'Berufsanfänger:innen',
      Berufsanfänger: 'Berufsanfänger:innen',
      PJ: 'PJler:innen',
      Famulatur: 'Famulant:innen',
      Assistenzarztzeit: 'Assistent:innen'
    }[word];
  } catch (error) {
    return null;
  }
};

const UserRating = ({ rating, style, onClick }) => {
  const [showAll, setShowAll] = React.useState(false);
  const ratingsByCategory = getRatingsByCategory(rating.ratings);
  const { t } = useContext(TrackingContext);
  let isCut = false;

  console.log(rating.user);

  const recommendedFor = (rating.ratings.find(r => r.category === 'overall')?.recommended_for || rating.ratings[0].recommended_for);

  return (
    <div className='clinic-user-ratings-wrapper' style={{ cursor: 'pointer', ...style }} onClick={() => { if (!showAll) t('action', 'open_rating'); setShowAll(!showAll); }}>

      <table style={{ width: '100%' }}>
        <tbody>
          <tr>
            {/* <td style={{ width: 60 }}><img src={UserIcon} width={45} /> </td> */}
            <td><b>{mapUserExperience[rating.user]}</b>, <span><i>{rating.time}</i></span></td>
            <td style={{ textAlign: 'center', fontSize: 28 }}><i className={rating.recommended === 1 ? 'fa fa-thumbs-up' : rating.recommended === -1 ? 'fa fa-thumbs-down' : 'fa fa-thumbs-down'} style={{ color: ratingColors[rating.recommended], transform: rating.recommended === 0 ? 'rotate(-90deg)' : null }} /></td>
          </tr>
        </tbody>
      </table>
      {/* <p style={{ fontWeight: 'bold', fontSize: 12, marginTop: 8 }}><i>Empfehlung für {rating.recommendedFor.join(', ')}</i></p> */}

      <table style={{ width: '100%' }}>
        <tbody>
          {
            Object.keys(ratingsByCategory).map(category => {
              if (category === 'overall') return null;
              let positiveCounts = 0;
              let negativeCounts = 0;
              let undecidedCounts = 0;
              const categoryRatings = ratingsByCategory[category]?.map(ratingObject => {
                if (ratingObject.recommended === -1) negativeCounts++;
                if (ratingObject.recommended === 1) positiveCounts++;
                if (ratingObject.recommended === 0) undecidedCounts++;
                return ratingObject;
              }).filter(r => r !== null) || [];
              const summedValue = getRatingValue({ n: negativeCounts, p: positiveCounts, u: undecidedCounts });
              const numberOfRatings = categoryRatings.length;
              return (
                <React.Fragment key={category}>
                  <tr>
                    <td
                      style={{
                        width: '1%',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <div style={{ backgroundColor: ratingColors[summedValue], width: 12, height: 12, borderRadius: '50%' }} />
                    </td>
                    <td style={{ paddingLeft: 15 }}>
                      <h5 style={{ marginBottom: 0 }}>
                        {categoryMapper[category]}
                      </h5>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>
                      {
                          categoryRatings.map((r, i) => {
                            if (numberOfRatings === 1 && !r.text) return <p className='rating-comments' style={{ color: 'grey', paddingLeft: 15, marginBottom: 10 }}><i>Keine Kommentare</i></p>;
                            if (!r.text) return null;
                            isCut = !isCut ? hasToCut(r.text || '') : true;
                            return (
                              <React.Fragment key={r.id}>
                                <p className='rating-comments' style={{ color: 'grey', paddingLeft: 15, marginBottom: (i + 1) === categoryRatings.length ? 10 : 0 }}>{r.text.indexOf('-') === 0 ? '' : '- '}{showAll ? r.text : cutText(r.text)}</p>
                              </React.Fragment>
                            );
                          })
                        }
                    </td>
                  </tr>

                </React.Fragment>
              );
            })
          }
          {
            (rating.ratings[0].recommended_for && rating.ratings[0].recommended === 1) &&
            (
              <>
                <tr>
                  <td
                    style={{
                      width: '1%',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <div style={{ backgroundColor: 'transparent', width: 12, height: 12, borderRadius: '50%', lineHeight: 1 }}>
                      <i className='fa fa-star' />
                    </div>
                  </td>
                  <td style={{ paddingLeft: 15 }}>
                    <h5 style={{ marginBottom: 0 }}>
                      Empfohlen für:
                    </h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    &nbsp;
                  </td>
                  <td style={{ paddingLeft: 15 }}>
                    <p style={{ color: 'grey', marginBottom: 0 }} className='rating-comments'>
                      {
                        (recommendedFor.length > 0 ? recommendedFor : ['PJ', 'Berufsstart', 'Famulatur', 'Assistenzarztzeit'])?.map((rec, i) => {
                          return (
                            <React.Fragment key={rec}>
                              {i === 0 ? <><i className='fa fa-user' />&nbsp;</> : ', '} {mapRecommended(rec) || rec}
                            </React.Fragment>
                          );
                        })
                      }
                    </p>
                  </td>
                </tr>
              </>
            )
          }
          {/* {
            rating.ratings.map((r, i) => {
              return (
                <React.Fragment key={'i1' + i}>
                  <tr>
                    <td>
                      <center><div style={{ backgroundColor: ratingColors[r.recommended], width: 12, height: 12, borderRadius: '50%' }} /></center>
                    </td>
                    <td style={{ paddingLeft: 15 }}>
                      <h5 style={{ marginBottom: 0, fontSize: 14, fontWeight: 'bold' }}>
                        {categoryMapper[r.category]}
                      </h5>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td><p style={{ color: 'grey', paddingLeft: 15, fontSize: 13 }}>{showAll ? r.text || 'keine Kommentare' : cutText(r.text || 'keine Kommentare')}</p></td>
                  </tr>
                </React.Fragment>
              );
            })
          } */}
        </tbody>
      </table>
      {
        isCut && (<a style={{ maxWidth: 150, float: 'right', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setShowAll(!showAll)} scale={1.1}>{showAll ? <><i className='fa fa-caret-up' /> Einklappen</> : <><i className='fa fa-caret-down' /> Ausklappen</>}</a>)
      }

      <div style={{ clear: 'both' }} />
    </div>
  );
};

export default UserRating;
